import { Box, HStack, VStack } from '@chakra-ui/react';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import { AppChart } from './app-chart.component';
import { AppMetrics } from './app-metrics.component';
import { LiveFeedMetrics } from './live-feed-metrics.component';
import { AppManualVerificationMetrics } from './manual-verification-metrics.component';
import { ProviderDetails } from './provider-details';

export const AppDashboard = () => {
  const { width } = useWindowDimensions();

  return (
    <Box
      display="flex"
      flexDir="column"
      justifyContent="center"
      backgroundColor="#FFF"
      // bgColor='palegoldenrod'
      h="fit-content"
      w={width > 1740 ? '1300px' : '95%'}
      alignItems="center"
    >
      <VStack w="100%" spacing={0} mb={6} alignItems="center">
        <AppMetrics />
        <AppChart />
        <HStack
          w="100%"
          spacing="28px"
          justifyContent="space-between"
          alignItems="flex-start"
        >
          <AppManualVerificationMetrics />
          <LiveFeedMetrics />
        </HStack>
        <ProviderDetails />
      </VStack>
    </Box>
  );
};
